export const validateSelectedTags = ( e ) => {
    const tags = document.getElementsByClassName("tag-selected");
    const frequency = document.getElementsByClassName("frequency-selected");

    // only returns true if both tags and frequency have selected options
    return tags.length && frequency.length
}